import React, { Component } from 'react';
import   SideNav from "../sidenav/sidenav.js"
import "./display.css"
import  Moble from "../sidenav/moble.js"
import * as Survey from "survey-react";
import _  from 'underscore';
import "survey-react/survey.css";

import {
    Redirect , Link 
  } from 'react-router-dom'



//   https://uvune-events.herokuapp.com

class Dispaly extends Component {

    
    constructor(props){
        super(props)
        this.state = {
            loading : false,
            errorend  : false,
            noticeMassage : "",
            noerorrpage :  true,
            datapayment :[],
            page:[],
            domain: 'https://uvune-events.herokuapp.com'         
        }

     
    }

    json = {
        elements: [
            
         
        ]
    }

    componentDidMount(){
        this.props.noerorrpage(this.state.noerorrpage)
        const { match: { params } } = this.props;
        // console.log("params.userId",params.id, "params all", params)
               
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
        };
        this.setState({
         loading:true
        })
        // console.log("public users param", params.id)
        fetch(this.state.domain+"/payment-item/"+params.id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
         console.log("public users", result)
        //  result.form_schema.forEach( (tuition, index) => {
        //        this.json.elements.push(tuition)
        //  })   
    
           this.setState({
               datapayment:result,
               typeForm : result.type,
               payment_id : result._id,
               page :result.form_schema
               
           })

          
          

        })

        // const tuitionData = result.data;
        //         //const tuitionData = [];
        //         const allCompletedTuitions = [];
        //          tuitionData.forEach( (tuition, index) => {
        //             console.log(`member --- ${index} =>`, tuition );
        //             fetch("https://uvunebeta.herokuapp.com/tuition-category/"+ tuition.tuition_category_id, requestOptions)
        //             .then(res => res.json())
        //             .then((result)=>{
        //                 if(result){
        //                     console.log("category============ ", result)
        //                     let category = result;
                            
                          
        //                     let completeTuition = {
        //                         ...tuition,
        //                         category: {
        //                             ...category
        //                         }
        //                     }

        //                     console.log("complet tuition", completeTuition);

        //                     allCompletedTuitions.push(completeTuition);

        //                     this.setState({
        //                         tuitions: allCompletedTuitions
        //                     });
        //                 }else{
        //                     this.setState({
        //                         // loadingTuition :true
        //                     }) 
        //                 }
        //             })

        //          })


    }


    
    onComplete(survey, options) {
        //Write survey results into database
        // console.log("Survey results: " + JSON.stringify(survey.data));
        
       }
  
      

  render() {
    var model = new Survey.Model(this.state.page);
    return (
  
        this.state.submitIftrue ? (                 
            <Redirect to={{    pathname: `${'/info'}`  }}/>
       ):
        !this.props.isAuthenticated ? (
      <div className="hero is-bold is-fullheight">
            <div className="level-item">
            <a className="button is-loading is-large is-light">Loading</a>
            </div>
            <div className="level-item">
            <span>Trying to login...</span>
            </div>
        </div>
           )
             :
            <div className="Tuition"> 
               <div className="Activity-moble-nav-body">
                    < Moble  logout={this.logout}/>
               </div>     
                    <SideNav vanImage={this.props.organizer.image_url} email={this.props.user.email} 
                    logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name}
                    organizers404={this.props.organizers404}
                    /> 
          
                   <div className="main"> 
                   <Survey.Survey model={model} onComplete={this.onComplete}/>
                  </div>  

                  <Link to={`/build/${this.state.datapayment._id }`}  className="button is-link is-small">
                                  <span className="icon is-small">
                                  <i className="fas fa-long-arrow-alt-left"></i>
                                  </span>
                                  <span> Back</span>
                 </Link>
            </div>
      )

  
  

}





}

export default Dispaly;


// WEBPACK FOOTER //
// ./src/component/build/dispaly.js